module.exports = new __parcel__URL__("privacy-policy-data-table-EU.90ad35db.png").toString();